import tvTheme, { tvTextStroke } from './tvTheme';

/** 背景写真が透けるオーバーレイ用（画面3など） */
export const tvAiryGlass = {
  guide: 'rgba(255,255,255,0.72)',
  panel: 'rgba(255,255,255,0.62)',
  header: 'rgba(255,255,255,0.78)',
  border: '2px solid rgba(255,255,255,0.88)',
  shadow: '0 4px 18px rgba(13,74,143,0.14)',
};

/** 駅前パネル等で使う放送グラフィック共通スタイル */
export const tvBroadcast = {
  root: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  header: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 0.75,
    px: 1,
    py: 0.55,
    background: 'linear-gradient(180deg, #ffffff 0%, #e8f4fc 100%)',
    borderBottom: '3px solid #fff',
    boxShadow: '0 3px 14px rgba(13,74,143,0.2)',
  },
  title: (compact) => ({
    fontSize: compact ? '1.2rem' : 'clamp(2rem, 3.8vw, 2.95rem)',
    fontWeight: 900,
    color: tvTheme.colors.titleOrange,
    ...tvTextStroke('#fff'),
    lineHeight: 1.05,
    whiteSpace: 'nowrap',
  }),
  locationTag: (compact) => ({
    fontSize: compact ? '0.78rem' : 'clamp(1.05rem, 1.65vw, 1.35rem)',
    fontWeight: 900,
    color: '#fff',
    ...tvTextStroke(tvTheme.colors.accentBlue),
    px: 0.75,
    py: 0.2,
    borderRadius: 1,
    bgcolor: 'rgba(21,101,184,0.85)',
    border: '2px solid #fff',
    flexShrink: 0,
  }),
  mainPlate: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    gap: 0.5,
    p: 0.5,
    bgcolor: 'rgba(255,255,255,0.96)',
    border: '3px solid #fff',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.8), 0 4px 18px rgba(13,74,143,0.15)',
  },
  chartPlate: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    bgcolor: '#f0f7fc',
    border: '2px solid #fff',
    borderRadius: 0.5,
    overflow: 'hidden',
  },
  chartSubhead: (compact) => ({
    flexShrink: 0,
    px: 0.75,
    py: compact ? 0.28 : 0.38,
    fontSize: compact ? '0.72rem' : 'clamp(0.95rem, 1.5vw, 1.2rem)',
    fontWeight: 900,
    color: '#fff',
    bgcolor: tvTheme.colors.labelBar,
    lineHeight: 1.2,
  }),
  ticker: (compact) => ({
    flexShrink: 0,
    width: '100%',
    boxSizing: 'border-box',
    px: compact ? 0.45 : 0.65,
    py: compact ? 0.5 : 0.75,
    background: tvTheme.colors.tickerBar,
    borderTop: '4px solid #fff',
    boxShadow: '0 -4px 14px rgba(13,74,143,0.25)',
  }),
  tickerText: (compact) => ({
    fontSize: compact ? '1.05rem' : 'clamp(1.75rem, 3.8vw, 3.15rem)',
    fontWeight: 900,
    color: '#fff',
    ...tvTextStroke('#0d47a1'),
    lineHeight: 1.25,
    textAlign: 'center',
    width: '100%',
    letterSpacing: '0.02em',
  }),
  dayBadge: (compact, emphasis = 'normal') => ({
    flexShrink: 0,
    width: compact ? 52 : emphasis === 'large' ? 88 : 72,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'stretch',
    background:
      emphasis === 'large'
        ? `linear-gradient(180deg, ${tvTheme.colors.titleOrange} 0%, #e65100 100%)`
        : `linear-gradient(180deg, ${tvTheme.colors.labelBar} 0%, #0d47a1 100%)`,
    borderRight: '3px solid #fff',
    px: 0.35,
  }),
  dayBadgeText: (compact, emphasis = 'normal') => ({
    fontSize:
      emphasis === 'large'
        ? compact
          ? '0.85rem'
          : 'clamp(1.1rem, 2vw, 1.5rem)'
        : compact
          ? '0.72rem'
          : 'clamp(0.9rem, 1.5vw, 1.2rem)',
    fontWeight: 900,
    color: '#fff',
    ...tvTextStroke(emphasis === 'large' ? '#bf360c' : '#0d47a1'),
    lineHeight: 1.1,
    textAlign: 'center',
  }),
  photoLarge: (compact) => ({
    flex: '0 0 auto',
    width: compact ? 72 : 'clamp(88px, 24%, 200px)',
    minHeight: compact ? 64 : 0,
    alignSelf: 'stretch',
    objectFit: 'cover',
    border: '3px solid #fff',
    borderRadius: 0.5,
    boxShadow: '0 4px 16px rgba(13,74,143,0.22)',
  }),
  photoSmall: (compact) => ({
    flex: '0 0 auto',
    width: compact ? 56 : 'clamp(72px, 20%, 120px)',
    alignSelf: 'stretch',
    objectFit: 'cover',
    border: '3px solid #fff',
    borderRadius: 0.5,
    boxShadow: '0 3px 12px rgba(13,74,143,0.2)',
  }),
  weekRow: (compact) => ({
    flex: 1,
    minHeight: 0,
    display: 'flex',
    alignItems: 'stretch',
    borderBottom: '2px solid #fff',
    '&:last-of-type': { borderBottom: 'none' },
  }),
};

export default tvBroadcast;
